import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import InvoiceEdit from "../InvoiceEdit";

function AdminInvoiceEdit(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={4}
        childrenPage={<InvoiceEdit/>}/>
        </DataContext.Provider>
    )
}

export default AdminInvoiceEdit;